import { privateAxios } from "../axiosInstances";
import { useQuery } from "@tanstack/react-query";
import acExpoDiscountCodeQueryKey from "../query-keys/discount-codes.query-keys";
import {
  DiscountCode,
  DiscountCodesFilters,
  DiscountCodeWithUses,
  Paginated,
  PaginatedResponse,
  Sortable,
} from "@ac-expo/api-types";

const getDiscountCodes = async (
  filters: Sortable<Paginated<DiscountCodesFilters>>
) => {
  const res = await privateAxios.get<PaginatedResponse<DiscountCodeWithUses>>(
    "/discount-codes",
    {
      params: filters,
    }
  );
  return res.data;
};

export const useGetDiscountCodes = (
  filters: Sortable<Paginated<DiscountCodesFilters>>
) => {
  return useQuery({
    queryKey: acExpoDiscountCodeQueryKey.lists(filters),
    queryFn: () => getDiscountCodes(filters),
  });
};

const getDiscountCode = async (id: string) => {
  const res = await privateAxios.get<DiscountCode>(`/discount-codes/${id}`);
  return res.data;
};

export const useGetDiscountCode = (id: string) => {
  return useQuery({
    queryKey: acExpoDiscountCodeQueryKey.detail(id),
    queryFn: () => getDiscountCode(id),
  });
};
